export function normalizeClientPhotos(raw) {
  if (!raw) return [];

  if (Array.isArray(raw)) {
    return raw.flatMap((item) => {
      if (typeof item === 'string' && item.trim()) return [item.trim()];
      if (item?.url && typeof item.url === 'string') return [item.url];
      if (item?.preview && typeof item.preview === 'string') return [item.preview];
      return [];
    });
  }

  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      return normalizeClientPhotos(parsed);
    } catch {
      return [trimmed];
    }
  }

  return [];
}

export function getClientAccessInfo(intervention = {}) {
  return (
    intervention.accessInfo
    || intervention.access_info
    || intervention.originalData?.accessInfo
    || intervention.originalData?.access_info
    || ''
  ).trim();
}

export function getClientComment(intervention = {}) {
  return (intervention.notes || '').trim();
}

export function getClientPhotos(intervention = {}) {
  const raw =
    intervention.photosclient
    ?? intervention.originalData?.photosclient
    ?? null;

  return normalizeClientPhotos(raw);
}
